export enum TabsType {
  activity = 'activity',
  subcontractor = 'subcontractor',
  assignees = 'assignees',
}
